export default "__VITE_ASSET___YXUZ9Sq__"